module.exports = __webpack_public_path__ + "static/media/ajax-Loader.fbf6d97e.gif";